<template>
  <div>
    <div class="page-bg page">
      <SubHeader :title="headerTitle"></SubHeader>

      <div class="page-content">
        <div class="form-wrap">
          <div class="input-password-title" style="margin-top: 0">
            请输入8位数字，字母密码，区分大小写
          </div>
          <div class="input-block">
            <div class="input-wrap">
              <input
                type="password"
                v-model="password"
                placeholder="请输入密码"
              />
            </div>
          </div>
          <div class="input-block">
            <div class="input-wrap">
              <input
                type="password"
                v-model="confirmPassword"
                placeholder="请再次输入密码"
              />
            </div>
          </div>

          <div class="input-block post-code">
            <div class="input-wrap">
              <input
                type="text"
                v-model="msgCode"
                maxlength="6"
                placeholder="请输入验证码"
              />
            </div>
            <div class="code-wrap">
              <span :class="{ success: isSendMsgCode }" @click="getMsgCode">{{
                msgCodeText
              }}</span>
            </div>
          </div>



          <div class="login-btn">
            <button @click="submit()" :disabled="!isSubmit">提交</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SubHeader from "../../../components/sub_header";
import Vue from "vue";
import { mapActions, mapState } from "vuex";
import { Toast } from "vant";
Vue.use(Toast);

export default {
  name: "login",
  data() {
    return {
      isSubmit: true,
      
      password: "",
      confirmPassword: "",

      msgCode: "",
      isSendMsgCode: true,
      msgCodeText: "发送验证码",

    };
  },
  components: {
    SubHeader,
  },

  created() {
    document.title = this.$route.meta.title;
    this.headerTitle = this.$route.meta.title;
  },
  methods: {
    ...mapActions({
      sendMessage: "user/sendMessage",
      updatePassword: "user/updatePassword",
    }),

    //提交注册
    async submit() {
      let vm = this;

      if (this.password.match(/^\s*$/)) {
        Toast("请输入密码");
        return;
      }

      if (this.password.length < 8) {
        Toast("密码格式不正确");
        return;
      }
      if (this.password !== this.confirmPassword) {
        Toast("两次密码不一致");
        return;
      }

      if (this.msgCode.match(/^\s*$/)) {
        Toast("请输入短信验证码");
        return;
      }



      let toastLoading = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
      });

      if (this.isSubmit) {

        let password = this.password;
        let confirmPassword = this.confirmPassword;
        let code = this.msgCode;

        let data = {
          code,
          password,
          confirmPassword,
        };
        

        this.updatePassword({
          data: data,
          success: (res) => {
            toastLoading.clear();
            // console.log(res);
            if (res.status === 1) {
              Toast({
                type: "success",
                message: "修改成功",
                onClose: function () {
                  vm.$router.go(-1);
                },
              });
            } else {
              Toast(res.message);
            }
          },
        });
      }
    },
    
    //获取短信验证码
    async getMsgCode() {
      if (this.isSendMsgCode) {

        let username = this.userInfo.mobile;
        if (username.match(/^\s*$/)) {
          Toast("请输入手机号");
          return;
        }
        if (!username.match(/^1[0-9][0-9]\d{8}$/)) {
          Toast("您输入的手机号格式不正确");
          return;
        }
        let toastLoading = Toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true,
        });

        this.isSendMsgCode = false;
        this.sendMessage({
          username: username,
          success: (res) => {
            toastLoading.clear();
            console.log(res);

            if (res.status == 1) {

              Toast("发送成功");

              let time = 60;
              this.msgCodeText = time + "s后重新获取";
              this.timer = setInterval(() => {
                if (time > 0) {
                  time--;
                  this.msgCodeText = time + "s后重新获取";
                } else {
                  clearInterval(this.timer);
                  this.msgCodeText = "发送验证码";
                  this.isSendMsgCode = true;
                }
              }, 1000);
            } else {
              Toast(res.message);
            }
          },
        });
      }
    },

  },

  computed: {
    ...mapState({
      isLogin: (state) => state.user.isLogin,
      userInfo: (state) => state.user.userInfo,
      guid: (state) => state.user.guid,
      security: (state) => state.user.security,
    }),
  },

  activated() {
    document.title = this.$route.meta.title;
    this.headerTitle = this.$route.meta.title;
  },

  beforeDestroy() {
    clearInterval(this.timer);
  },

};
</script>

<style lang="scss" scoped>
.page {
  width: 100%;
  background-size: cover;
  padding-bottom: 1.2rem;
  box-sizing: border-box;
  height: 100vh;
}

.page-content {
  padding: 0 0.25rem;
}

.input-password-title {
  font-size: 0.24rem;
  color: #e09647;
  margin-top: 1.27rem;
}
.input-block {
  display: flex;
  align-items: center;
  width: 100%;
  border-bottom: 0.02rem solid #000002;
  margin-bottom: 0.6rem;
  max-width: 100%;
  .input-wrap {
    overflow: hidden;
    flex: 1;
    box-sizing: border-box;
    input {
      border: none;
      padding: 0;
      box-sizing: border-box;
      background-color: transparent;
      line-height: 0.96rem;
      font-size: 0.36rem;
      color: #101010;
      padding-left: 0.05rem;
      width: 100%;

      &::placeholder {
        color: #525252;
        font-size: 0.3rem;
      }
    }
  }

  &.post-code {
    width: 4.35rem;
    margin: 0 auto;
    align-items: flex-end;

    input {
      line-height: 0.76rem;
      box-sizing: border-box;
    }
    .code-wrap {
      padding-bottom: 0.05rem;
      span {
        font-size: 0.2rem;
        color: #4b2e0b;
        height: 0.43rem;
        min-width: 1.23rem;
        background: #f7c998;
        border-radius: 0.1rem;
        display: block;
        text-align: center;
        line-height: 0.43rem;
        white-space: nowrap;
        padding: 0 0.1rem;
      }
    }
  }
}
.login-btn {
  text-align: center;
  width: 6.2rem;
  line-height: 0.85rem;
  margin: 0 auto;
  margin-top: 1rem;
  button {
    color: #fff;
    border-radius: 0.42rem;
    line-height: 0.85rem;
    font-size: 0.3rem;
    width: 100%;
    background: linear-gradient(90deg, #ecb84a, #ea742c);
    cursor: pointer;
    &:disabled {
      background: #9e9e9e;
    }
  }
}
.agreement {
  text-align: center;
  font-size: 0.24rem;
  color: #525252;
  margin-top: 0.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  .dot {
    width: 0.23rem;
    height: 0.23rem;
    background: url("../../../assets/images/home/login/ic-1.png") no-repeat;
    background-size: 100%;
    margin-right: 0.1rem;
    &.active {
      background: url("../../../assets/images/home/login/ic-1-on.png") no-repeat;
      background-size: 100%;
    }
  }
}
.yellow {
  color: #e09647;
}

.page-content {
  margin-top: 0.6rem;
}
.login-btn {
  margin-top: 1.4rem;
}

.input-link {
  text-align: right;
  a {
    font-size: 0.24rem;
    color: #e09647;
    margin-left: 0.4rem;
    position: relative;
    padding-bottom: 0.1rem;
    &::after {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 0.02rem;
      background: #e09647;
    }
  }
}
</style>